import React, { useEffect } from 'react';
import SummariesList from '../SummariesList/SummariesList';
import './ComponentToPrint.css';
import { Grid } from '@mui/material';

export const ComponentToPrint = React.forwardRef((props, ref) => {
  const handlePrint = props.handlePrint

  useEffect(() => {
    setTimeout(() => {
      handlePrint();
    }, 2000);
  }, [handlePrint])

  return (
    <Grid ref={ref} container spacing={1} sx={{ position: 'relative'}} className="content" style={{ height: 'auto'}}>
      <Grid item size={12} className="print-column">
        <SummariesList
          key="SummariesList"
          summaries={props.summaries ? props.summaries : []}
          activityFeatures={props.activityFeatures ? props.activityFeatures : []}
          treatmentFeatures={props.treatmentFeatures ? props.treatmentFeatures : []}
          estimatedCombinedFeatures={props.estimatedCombinedFeatures ? props.estimatedCombinedFeatures : []}
          definitionExpression={props.definitionExpression}
          selectedClasses={props.selectedClasses ? props.selectedClasses : []}
          actualActivityFeatures={props.actualActivityFeatures ? props.actualActivityFeatures : []}
          actualTreatmentFeatures={props.actualTreatmentFeatures ? props.actualTreatmentFeatures : []}
          actualCombinedFeatures={props.actualCombinedFeatures ? props.actualCombinedFeatures : []}
          isPrinting={props.isPrinting}
          treatmentFundingFeatures={props.treatmentFundingFeatures ? props.treatmentFundingFeatures : []}
          activityFundingFeatures={props.activityFundingFeatures ? props.activityFundingFeatures : []}
          actualTreatmentFundingFeatures={props.actualTreatmentFundingFeatures ? props.actualTreatmentFundingFeatures : []}
          actualActivityFundingFeatures={props.actualActivityFundingFeatures ? props.actualActivityFundingFeatures : []}
          estimatedCombinedFundingFeatures={props.estimatedCombinedFundingFeatures ? props.estimatedCombinedFundingFeatures : []}
          actualCombinedFundingFeatures={props.actualCombinedFundingFeatures ? props.actualCombinedFundingFeatures : []}
          isTreatmentsLoaded={props.isTreatmentsLoaded}
          isActivitiesLoaded={props.isActivitiesLoaded}
          isActTreatmentsLoaded={props.isActTreatmentsLoaded}
          isActActivitiesLoaded={props.isActActivitiesLoaded}
          isCheckboxChanged={false}
          isTreatmentFundingLoaded={props.isTreatmentFundingLoaded} 
          isActivityFundingLoaded={props.isActivityFundingLoaded} 
          isActActivityFundingLoaded={props.isActActivityFundingLoaded} 
          isActTreatmentFundingLoaded={props.isActTreatmentFundingLoaded}
        />
      </Grid>
    </Grid>
  )
})